import _ from 'underscore';

import {assert} from 'Asserts';
import {Sequence} from 'components/Sequence';
import {Cutsite, Strand} from 'constants/MolbioConstants';
import {Enzyme} from 'molbio/enzymes/backbone/Enzymes';

interface SiteInsideFragmentOptions {
  start?: number | null;
  end?: number | null;
  cutsites: Array<Cutsite>;
}

export function siteInsideFragment(
  enzyme: Enzyme,
  {start, end, cutsites}: SiteInsideFragmentOptions
): boolean {
  assert(enzyme.get('cut') !== 0, `enzyme=${enzyme.get('id')} cuts at its recognition site`);
  assert(start != null || end != null, `Both start=${start} and end=${end} are not defined`);
  const position: number = start ?? end!;
  assert(
    _.findWhere(cutsites, {position}) != null,
    `enzyme=${enzyme.get('id')} \
cutsites=${JSON.stringify(cutsites)} don't include start=${start} or end=${end}`
  );
  // Find the strand that corresponds to the cutsite being inside the fragment. For example, if the
  // BbsI cutsite at the fragment start is on the reverse strand, then the recognition site is
  // inside the fragment.
  //
  //     AGTAAAGTCTTC
  //     TCATTTCAGAAG
  //     ^          ^
  //   start   recog. site
  let siteInsideFragmentStrand: Strand;
  if (start != null) {
    if (enzyme.get('cut') > 0) {
      siteInsideFragmentStrand = -1;
    } else {
      siteInsideFragmentStrand = 1;
    }
  } else if (enzyme.get('cut') > 0) {
    siteInsideFragmentStrand = 1;
  } else {
    siteInsideFragmentStrand = -1;
  }
  return _.findWhere(cutsites, {position, strand: siteInsideFragmentStrand}) != null;
}

export function getSitesInsideFragmentWarning(
  sequence: Sequence,
  enzyme: Enzyme,
  {start, end, cutsites}: SiteInsideFragmentOptions
): string | null {
  const atStart = start != null ? siteInsideFragment(enzyme, {start, cutsites}) : undefined;
  const atEnd = end != null ? siteInsideFragment(enzyme, {end, cutsites}) : undefined;
  if (atStart && atEnd) {
    let warning = 'Recognition sites are inside fragment.';
    if (sequence.circular()) {
      warning += ' Flip start and end.';
    }
    return warning;
  }
  if (atStart) {
    return 'Start recognition site is inside fragment.';
  }
  if (atEnd) {
    return 'End recognition site is inside fragment.';
  }
  return null;
}
